import React, { useState } from 'react';
import { Card } from '../shared/Card';
import ReactPlayer from 'react-player';
interface HomeScreenProps {
  navigateTo: (screen: string) => void;
  userName?: string;
}
export const HomeScreen = ({
  navigateTo,
  userName = 'Fitness Friend'
}: HomeScreenProps) => {
  const [videoPlaying, setVideoPlaying] = useState(false);
  // Sample recommended video data
  const recommendedVideo = {
    title: '10-min Stress Relief Workout',
    description: 'Calm your mind and relieve tension with gentle movements',
    duration: '10',
    thumbnail: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80',
    videoUrl: 'https://www.youtube.com/watch?v=inpok4MKVLM',
    intensity: 'medium',
    equipment: 'No equipment',
    rating: 4.8,
    reviews: 240
  };
  const handlePlayClick = () => {
    setVideoPlaying(true);
  };
  return <div className="flex flex-col h-full min-h-screen bg-white pb-16" data-id="element-523">
      <header className="p-6 border-b border-gray-100" data-id="element-524">
        <div className="flex items-center" data-id="element-525">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9qPx53UyjZGfyvkE6gkvqL/01_FitFuel_Logo.png" alt="FitFuel Logo" className="h-24 mr-2" data-id="element-526" />
        </div>
        <div className="mt-4" data-id="element-527">
          <h2 className="text-lg font-medium" data-id="element-528">Welcome back, {userName}!</h2>
          <p className="text-gray-500" data-id="element-529">What would you like to do today?</p>
        </div>
      </header>
      <main className="flex-1 p-6 space-y-6 overflow-y-auto" data-id="element-530">
        <Card onClick={() => !videoPlaying && navigateTo('quickstart')} className="p-6 bg-blue-500 text-white overflow-hidden" data-id="element-531">
          <div className="flex items-center mb-4" data-id="element-532">
            <div className="w-12 h-12 bg-blue-400 rounded-full flex items-center justify-center mr-4" data-id="element-533">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-534">
                <polygon points="5 3 19 12 5 21 5 3" data-id="element-535"></polygon>
              </svg>
            </div>
            <div data-id="element-536">
              <h3 className="text-xl font-bold text-black" data-id="element-537">
                Jump into a Video
              </h3>
              <p className="text-blue-100" data-id="element-538">QuickStart personalized workout</p>
            </div>
          </div>
          <h2 className="text-xl font-bold text-black mb-2" data-id="element-539">
            {recommendedVideo.title}
          </h2>
          <div className="relative rounded-lg overflow-hidden mb-3" style={{
          height: videoPlaying ? 'auto' : '140px'
        }} data-id="element-540">
            {videoPlaying ? <div className="relative pt-[56.25%]" data-id="element-541">
                <ReactPlayer url={recommendedVideo.videoUrl} playing={true} controls={true} width="100%" height="100%" style={{
              position: 'absolute',
              top: 0,
              left: 0
            }} onEnded={() => setVideoPlaying(false)} onClickPreview={e => e.stopPropagation()} data-id="element-542" />
              </div> : <>
                <img src={recommendedVideo.thumbnail} alt={recommendedVideo.title} className="w-full h-full object-cover rounded-lg" data-id="element-543" />
                <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center cursor-pointer" onClick={e => {
              e.stopPropagation();
              handlePlayClick();
            }} data-id="element-544">
                  <div className="w-12 h-12 bg-white bg-opacity-80 rounded-full flex items-center justify-center transform transition-transform hover:scale-110" data-id="element-545">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-blue-500" data-id="element-546">
                      <polygon points="5 3 19 12 5 21 5 3" data-id="element-547"></polygon>
                    </svg>
                  </div>
                </div>
                <div className="absolute top-2 right-2 bg-blue-600 text-white text-xs font-medium px-1.5 py-0.5 rounded-full" data-id="element-548">
                  {recommendedVideo.duration} min
                </div>
              </>}
          </div>
          <div className="bg-blue-600 rounded-lg p-3 text-sm" data-id="element-549">
            <p data-id="element-550">{recommendedVideo.description}</p>
            {!videoPlaying && <div className="flex items-center text-xs text-blue-200 mt-1" data-id="element-551">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-1 text-yellow-300" data-id="element-552">
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" data-id="element-553"></polygon>
                </svg>
                {recommendedVideo.rating} ({recommendedVideo.reviews} reviews)
              </div>}
          </div>
        </Card>
        <Card onClick={() => navigateTo('gym')} className="p-6" data-id="element-554">
          <div className="flex items-center" data-id="element-555">
            <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mr-4 text-orange-500" data-id="element-556">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-557">
                <path d="M4 15v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" data-id="element-558"></path>
                <rect width="8" height="7" x="8" y="8" rx="1" data-id="element-559"></rect>
                <path d="M8 8V7a4 4 0 0 1 8 0v1" data-id="element-560"></path>
              </svg>
            </div>
            <div data-id="element-561">
              <h3 className="text-xl font-bold text-gray-900" data-id="element-562">
                Log a Gym Session
              </h3>
              <p className="text-gray-500" data-id="element-563">Track your sets, reps & weights</p>
            </div>
          </div>
        </Card>
        <Card onClick={() => navigateTo('workout-creation')} className="p-6" data-id="element-564">
          <div className="flex items-center" data-id="element-565">
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mr-4 text-green-500" data-id="element-566">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-567">
                <rect width="18" height="18" x="3" y="3" rx="2" ry="2" data-id="element-568"></rect>
                <line x1="3" x2="21" y1="9" y2="9" data-id="element-569"></line>
                <line x1="9" x2="9" y1="21" y2="9" data-id="element-570"></line>
              </svg>
            </div>
            <div data-id="element-571">
              <h3 className="text-xl font-bold text-gray-900" data-id="element-572">
                Create Workout or Plan
              </h3>
              <p className="text-gray-500" data-id="element-573">FitFuel will create it for you</p>
            </div>
          </div>
        </Card>
      </main>
      <div className="p-4 border-t border-gray-100 mb-16" data-id="element-574">
        <div className="bg-blue-50 rounded-xl p-4" data-id="element-575">
          <div className="flex items-start" data-id="element-576">
            <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center mr-3 text-blue-500 flex-shrink-0" data-id="element-577">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-578">
                <circle cx="12" cy="12" r="10" data-id="element-579"></circle>
                <path d="m9 12 2 2 4-4" data-id="element-580"></path>
              </svg>
            </div>
            <div data-id="element-581">
              <h3 className="text-sm font-medium text-blue-800" data-id="element-582">
                Keep the momentum going!
              </h3>
              <p className="text-xs text-blue-600 mt-1" data-id="element-583">
                You've completed 2 workouts this week. Just 1 more to hit your
                goal!
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
};